import React, { useState } from 'react'

// includes
import EditMode from './includes/EditMode'
import SkeletonLoading from './AdminEmailAddresses__loadingSkeleton'

export default function AdminEmailAddresses(props) {
    // props
    const {
        loading,
        notificationsData,
        setNotificationsData,
    } = props

    // states
    const [editModeVisibility, setEditModeVisibility] = useState(false)

    // on edit button clicked
    const handleEditClick = ev => {
        ev.preventDefault()

        setEditModeVisibility(!editModeVisibility) // showing edit mode
    }

    return (
        <React.Fragment>
            {
                loading ? ( // while loading
                    <div className="page-border-box2 mb-3 mb-md-4 domain-info">
                        <div className="pbb2-inner">
                            <SkeletonLoading />
                        </div>
                    </div>
                ) : (
                    <React.Fragment>
                        {
                            /* header */
                            editModeVisibility ? (
                                <EditMode
                                    notificationsData={notificationsData}
                                    setNotificationsData={setNotificationsData}

                                    setEditModeVisibility={setEditModeVisibility}
                                />
                            ) : (
                                <React.Fragment>
                                    <div className={`page-border-box2 mb-3 mb-md-4 customer-order-notifications`}>
                                        <div className="pbb2-inner d-flex">
                                            {/* text sec */}
                                            <div className="text-sec media-body pe-3">
                                                <div className="app-header-wrapper heading-sm mb-2">
                                                    <p className="app-heading text-capitalize mb-2">Admin email addresses</p>
                                                    <p className="app-desc st-fs-14">
                                                        All admin notifications are sent to the specified email address. You can specify multiple addresses.
                                                    </p>
                                                </div>

                                                <p className="add-info text-black-50">
                                                    Admin notifications are sent to {notificationsData?.admin_email_address?.join(", ")}
                                                </p>
                                            </div>

                                            <div className="btn-sec">
                                                <button className="st-btn st-btn-sm" onClick={handleEditClick}>
                                                    Edit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )
                        }
                    </React.Fragment>
                )
            }

        </React.Fragment>
    )
}
